import http from '../index'
let lang = localStorage.getItem('2d3d-language')
if(!lang){
	lang = "en-us"
}

// 获取通用模型数据
export const createDataByPages = (obj) =>{
	return http.post("/v3/ActionModule/createDataByPages",obj);
};

// 照片建模-保存照片
export const saveFunPhoto = (obj) =>{
	return http.post("/v4/ActionModule/saveFunPhoto?lang="+lang,obj);
};

// 照片建模-生成抠图
export const generateFunCutout = (task_id) =>{
	return http.post("/v4/ActionModule/generateFunCutout?lang="+lang,{task_id});
};

// 照片建模-生成预览图
export const generateFun3DPreview = (task_id) =>{
	return http.post("/v4/ActionModule/generateFun3DPreview?lang="+lang,{task_id});
};

// 照片建模-监听预览图
export const listenFun3DPreview = (task_preview_no) =>{
	return http.post("/v4/ActionModule/listenFun3DPreview?lang="+lang,{task_preview_no});
};

// 照片建模-生成3D模型
export const generateFun3DModel = (task_preview_no) =>{
	return http.post("/v4/ActionModule/generateFun3DModel?lang="+lang,{task_preview_no});
};

// 文本建模-生成文本3D模型【新】
export const pushFun3DModel = (task_id) =>{
	return http.post("/v4/ActionModule/pushFun3DModel?lang="+lang,{task_id});
};


// 照片建模-监听3D模型
export const listenFun3DModel = (task_preview_no) =>{
	return http.post("/v4/ActionModule/listenFun3DModel?lang="+lang,{task_preview_no});
};

// 照片建模-取消
export const cancelFun3DModel = (task_preview_no) =>{
	return http.post("/v4/ActionModule/cancelFun3DModel?lang="+lang,{task_preview_no});
};

// 文本建模-关键词列表
export const getTextKeywordList = () =>{
	return http.get("/v4/ActionModule/getTextKeywordList?lang="+lang);
};

// 文本建模-生成文本缩略图
export const generateTextThumbnails = (content) =>{
	return http.post("/v4/ActionModule/generateTextThumbnails?lang="+lang,{content});
};

// 文本建模-生成文本预览图
export const generateText3DPreview = (obj) =>{
	return http.post("/v4/ActionModule/generateText3DPreview?lang="+lang,obj);
};

// 文本建模-监听文本预览图
export const listenText3DPreview = (task_preview_no) =>{
	return http.post("/v4/ActionModule/listenText3DPreview?lang="+lang,{task_preview_no});
};

// 文本建模-生成文本3D模型
export const generateText3DModel = (task_preview_no) =>{
	return http.post("/v4/ActionModule/generateText3DModel?lang="+lang,{task_preview_no});
};

// 文本建模-生成文本3D模型【新】
export const pushText3DModel = (task_id, key) =>{
	return http.post("/v4/ActionModule/pushText3DModel?lang="+lang,{task_id, key});
};

// 文本建模-监听文本3D模型
export const listenText3DModel = (task_preview_no) =>{
	return http.post("/v4/ActionModule/listenText3DModel?lang="+lang,{task_preview_no});
};

// 模型组搜索
export const moduleGroupSearch = (obj) =>{
	return http.post("/v3/ActionPublic/moduleGroupSearch?lang="+lang,obj);
};

// 上传文件
export const uploadFile = (obj) =>{
	return http.post("/v3/ActionModule/uploadFile?lang="+lang,obj);
};

// 保存模型
export const saveUserModuleInfo = (obj) =>{
	return http.post("/v3/ActionModule/saveUserModuleInfo?lang="+lang,obj);
};

// 模型搜索
export const moduleSearch = (obj) =>{
	return http.post("/v3/ActionPublic/moduleSearch?lang="+lang,obj);
};

// 历史建模列表
export const getUserHistoryList = (obj) =>{
	return http.post("/v4//ActionModule/getUserHistoryList?lang="+lang,obj);
};

// 用户积分余额
export const getUserPoint = () =>{
	return http.post("/v4/ActionCenter/getUserPoint?lang="+lang);
};

// 用户积分-增加/扣减
export const changeUserPoint = (obj) =>{
	return http.post("/v3/ActionPublic/changeUserPoint?lang="+lang,obj);
};

// 兑换码兑换积分接口
export const toRedeemPoints = (code) =>{
	return http.post("/v4/ActionCenter/toRedeemPoints?lang="+lang,{code});
};


// 用户积分-明细
export const getUserPointList = (obj) =>{
	return http.get("/v3/ActionPublic/getUserPointList?lang="+lang+'&page='+obj.page+'&page_size='+obj.page_size+'&type='+obj.type);
};

// 照片建模-模型样例
export const getPhotoExampleList = (number) =>{
	return http.post("/v4//ActionModule/getPhotoExampleList?lang="+lang+'&number='+number);
};

// 热门模型/最新上线-TOP6  首页轮播图
export const getRandGroupListByScene = () =>{
	return http.get("/v3/ActionPublic/getRandGroupListByScene?lang="+lang+'&scene=1&number=30');
};

//创作星球模型列表
export const getModelsGroupByBar = () =>{
	return http.get("/v3/ActionPublic/getModelsGroupByBar?lang="+lang+'&label=creative&category_id=0&page=1&page_size=30');
};

// 购买方案列表
export const rechargePointsScheme = () =>{
	return http.get("/v4/ActionCenter/rechargePointsScheme?lang="+lang);
};

// 去支付
export const toRechargePoints = (scheme_id) =>{
	return http.post("/v4/ActionCenter/toRechargePoints?lang="+lang,{scheme_id});
};


